import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Chip, IconButton, styled, Tooltip } from "@mui/material";
import { possibleNames } from "../../Utils/constant";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import HeightIcon from "@mui/icons-material/Height";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function EstimateTable(props) {
  const {
    cart,
    totalAmount,
    handleDeleteProduct,
    handleChangeQuantity,
    isCloned,
  } = props;
  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>S No.</StyledTableCell>
              <StyledTableCell>Particulars</StyledTableCell>
              <StyledTableCell align="center">Quantity</StyledTableCell>
              <StyledTableCell align="center">Unit Price</StyledTableCell>
              <StyledTableCell align="center">Amount</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cart &&
              cart.map((row, idx) => (
                <StyledTableRow sx={{ height: "85px" }} key={row.id}>
                  <StyledTableCell component="th" scope="row">
                    {idx + 1}.
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.title}
                    {row?.productType && <br />}
                    {row?.productType}
                    <br />
                    {row?.options &&
                      row?.options?.map((option, idx) => {
                        if (option?.name === "Title") {
                          return null;
                        }
                        if (
                          possibleNames.includes(option?.name.toLowerCase())
                        ) {
                          return null;
                        }
                        return (
                          <Chip
                            key={idx}
                            variant="outlined"
                            label={`${option?.name}: ${row?.selectedOption[idx]}`}
                          />
                        );
                      })}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row?.quantity * row?.totalPc} {row?.unit || "PC"}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {/* ₹{row?.price} */}
                    {row?.price && ` ₹${parseInt(row?.price) / row?.totalPc}`}
                  </StyledTableCell>
                  <StyledTableCell align="center">{` ₹${row?.totalPrice}`}</StyledTableCell>
                  <StyledTableCell align="center">
                    <span>
                      <Tooltip title="Change Quantity" placement="top">
                        <IconButton
                          onClick={() => handleChangeQuantity(row, idx)}
                          color="info"
                        >
                          <HeightIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete" placement="top">
                        <IconButton
                          onClick={() => handleDeleteProduct(row, idx)}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </StyledTableCell>
                </StyledTableRow>
              ))}

            <StyledTableRow>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell align="center">
                {" "}
                <strong> Total </strong>
              </StyledTableCell>

              <StyledTableCell align="center">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <strong> ₹{totalAmount} </strong>
                  {(isCloned === true || isCloned === false) && (
                    <Tooltip
                      title={
                        isCloned
                          ? "Total amount is correct"
                          : "Total amount is incorrect"
                      }
                      placement="top"
                    >
                      {isCloned ? (
                        <CheckCircleIcon
                          sx={{ color: "green", fontSize: "20px" }}
                        />
                      ) : (
                        <CancelIcon sx={{ color: "red", fontSize: "20px" }} />
                      )}
                    </Tooltip>
                  )}
                </div>
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
